var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34969 2.5226C4.34969 3.35267 3.71767 4.02442 2.72928 4.02442C1.77941 4.02442 1.14739 3.35267 1.16695 2.5226C1.14739 1.65219 1.7794 1 2.74822 1C3.71765 1 4.33074 1.65219 4.34969 2.5226ZM1.24641 14.8795V5.21084H4.25128V14.8789H1.24641V14.8795Z",
    fill: "#686E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65979 8.29644C6.65979 7.09046 6.62005 6.06234 6.58032 5.21211H9.19033L9.32907 6.53667H9.38837C9.78385 5.9236 10.7722 4.99512 12.3737 4.99512C14.3505 4.99512 15.8333 6.30012 15.8333 9.14606V14.8807H12.8284V9.52259C12.8284 8.27626 12.3939 7.42664 11.3065 7.42664C10.4758 7.42664 9.9819 7.99998 9.78447 8.55316C9.705 8.7512 9.66588 9.02748 9.66588 9.30498V14.8807H6.661V8.29644H6.65979Z",
    fill: "#686E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLinkedin);
export default __webpack_public_path__ + "static/media/iconsLinkedin.62bdae230dea26a53dcb705973f29b13.svg";
export { ForwardRef as ReactComponent };